import React from "react";
import toast from "react-hot-toast";
import CourierContext from "contexts/courierContext";
import { ICourier, ICourierServiceCreate } from "../types/courier.interface";
import {
  addCourierService,
  getCourier,
  getCourierServices,
  removeCourierService,
  updateCourierService,
} from "api/CourierAPI";

const useCourierDetail = (id: string) => {
  const [isLoading, setIsLoading] = React.useState(true);
  const [courier, setCourier] = React.useState<ICourier>(null);
  const { services, setServices } = React.useContext(CourierContext);

  const getCourierDetail = () => {
    const promise = getCourier(id);
    promise
      .then((res) => {
        const courierData = res.data?.data;
        setCourier(courierData);
        if (!courierData.is_third_party) fetchServices(parseInt(id));
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        toast.error(
          err?.response?.data?.message || "Gagal mengambil detail kurir"
        );
      });
  };

  const fetchServices = async (courierId: number) => {
    const response = await getCourierServices(courierId);
    setServices(response.data.data);
  };

  const handleRemoveService = (serviceId: number) => {
    const promise = removeCourierService(parseInt(id), serviceId);

    toast.promise(promise, {
      loading: "Menghapus layanan...",
      success: () => {
        fetchServices(parseInt(id));
        return "Berhasil menghapus layanan";
      },
      error: "Gagal menghapus layanan!",
    });
  };

  const onSubmit = async (courierId: number, data: ICourierServiceCreate) => {
    setIsLoading(true);

    const priceByWeight = data.price_by_weight.replace(/\D/g, "");
    const priceByDistance = data.price_by_km.replace(/\D/g, "");
    data.price_by_weight = priceByWeight;
    data.price_by_km = priceByDistance;

    const promise = addCourierService(courierId, data);

    toast.promise(promise, {
      loading: "Menambahkan layanan...",
      success: "Berhasil menambahkan layanan",
      error: "Gagal menambahkan layanan!",
    });
    setIsLoading(false);

    return promise;
  };

  const onUpdate = async (
    courierId: number,
    serviceId: number,
    data: ICourierServiceCreate
  ) => {
    setIsLoading(true);

    const priceByWeight =
      typeof data.price_by_weight === "string"
        ? data.price_by_weight.replace(/\D/g, "")
        : data.price_by_weight;
    const priceByDistance =
      typeof data.price_by_km === "string"
        ? data.price_by_km.replace(/\D/g, "")
        : data.price_by_km;
    data.price_by_weight = priceByWeight;
    data.price_by_km = priceByDistance;

    const promise = updateCourierService(courierId, serviceId, data);

    toast.promise(promise, {
      loading: "Menyimpan perubahan...",
      success: "Berhasil menyimpan perubahan",
      error: "Gagal menyimpan perubahan!",
    });
    setIsLoading(false);

    return promise;
  };

  return {
    isLoading,
    services,
    courier,
    getCourierDetail,
    fetchServices,
    handleRemoveService,
    onSubmit,
    onUpdate,
  };
};

export default useCourierDetail;
